import Links from "@/shared/constants/navegacao";
import { DataAmigavel } from "@/shared/utils/datas";
import { Fragment } from "react/jsx-runtime";
import { LOCALIZACAO_SISTEMA } from '@/shared/constants/strings';
import { Link } from "react-router-dom";
import { RMovimentoDto } from "@/api.types";
import { textoCivelCriminal } from "../movimentacao.service";

type TabelaResumoMovimentacoesProps = {
  dados: RMovimentoDto[];
};

export function MovimentacoesPorDefensorTable({ dados }: TabelaResumoMovimentacoesProps) {
  return <table id="movimentacoesPorDefensorTable" className="table table-bordered table-sm table-striped">
    <thead>
      <tr>
        <th colSpan={3}>
          Defensor
        </th>
        <th>
          Atendimentos
        </th>
      </tr>
    </thead>
    <tbody>
      {/* Exibição dos dados da tabela */}
      {!dados ||
        (dados && dados.length <= 0 && (
          <tr>
            <td colSpan={3}>
              <h5 className="text-center">
                (Nenhum registro para os filtros selecionados)
              </h5>
            </td>
          </tr>
        ))}

      {dados &&
        dados.map((itemDefensor, index) => {
          return (
            <Fragment key={index}>
              <tr>
                <td className="fw-bold" colSpan={5}>
                  {itemDefensor.defensor}
                </td>
              </tr>
              {itemDefensor.recebimentos &&
                itemDefensor.recebimentos.map(
                  (itemMovimento, index2) => {
                    return (
                      <Fragment key={index2}>
                        <tr>
                          <td
                            colSpan={4}
                            className="fst-italic border-bottom"
                          >
                            <b>
                              <Link
                                className="link-secondary"
                                to={Links.Movimentacoes_Editar +
                                  '/' +
                                  itemMovimento.id +
                                  `?ehnucleo=${itemMovimento.nucleo ? 'true' : 'false'}`}
                              >
                                Referência:{' '}
                              </Link>{' '}
                              {(new Date(itemMovimento.referencia)).toLocaleDateString(LOCALIZACAO_SISTEMA, { year: 'numeric', month: 'short' })}
                            </b>{' '}
                            - Recebido em:{' '}
                            {DataAmigavel(
                              itemMovimento.data_recebimento
                            )}{' '}
                            -{' '}
                            <span className="text-muted">
                              {textoCivelCriminal(
                                itemMovimento.civel,
                                itemMovimento.criminal
                              )}
                            </span>
                            {' - '}
                            {itemMovimento.defensoria}
                            {itemMovimento.nucleo}{' '}
                            <b>
                              {itemMovimento.distrito
                                ? ' - ' + itemMovimento.distrito
                                : ''}
                            </b>
                          </td>
                        </tr>
                        {itemMovimento.registros &&
                          itemMovimento.registros.map(
                            (itemRegistro, index3) => {
                              return (
                                <Fragment key={index3}>
                                  <tr>
                                    <td className="text-center">
                                      {itemRegistro.inicial
                                        ? '(inicial)'
                                        : ''}
                                    </td>
                                    <td className="col-fixa">
                                      {itemRegistro.tipo}{' '}
                                      {itemRegistro.processos
                                        ? ' (' +
                                        itemRegistro.processos +
                                        ') '
                                        : ''}
                                    </td>
                                    <td></td>
                                    <td className="text-end">
                                      {itemRegistro.quantidade}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            }
                          )}
                        <tr className="fst-italic text-end border-top">
                          <td>Obs.:</td>
                          <td>{itemMovimento.observacao}</td>
                          <td
                            title={`${itemMovimento.defensoria}${itemMovimento.nucleo}`}
                          >
                            Total por Local:{' '}
                          </td>
                          <td>
                            {itemMovimento.registros.reduce(
                              (acumulador, subItemRegistros) => Number(acumulador) +
                                Number(subItemRegistros.quantidade),
                              0
                            )}
                          </td>
                        </tr>
                      </Fragment>
                    );
                  }
                )}
              <tr>
                <td colSpan={2}></td>
                <td
                  className="fst-italic text-end border-bottom"
                  title={itemDefensor.defensor}
                >
                  Total do Defensor(a):{' '}
                </td>
                <td className="fw-bold fst-italic text-end border-bottom">
                  {itemDefensor.recebimentos.reduce(
                    (acumulador, subItens) => Number(acumulador) +
                      Number(
                        subItens.registros.reduce(
                          (ac, sb) => Number(ac) + Number(sb.quantidade),
                          0
                        )
                      ),
                    0
                  )}
                </td>
              </tr>
            </Fragment>
          );
        })}
      <tr>
        <td
          colSpan={3}
          className="fst-italic text-end border-bottom"
          title="Total Geral"
        >
          Total Geral:{' '}
        </td>
        <td
          colSpan={2}
          className="fw-bold fst-italic text-end border-bottom"
        >
          {Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            currency: 'BRL',
          }).format(
            dados.reduce(
              (accumulator, currentValue) => accumulator +
                currentValue.recebimentos.reduce(
                  (ac2, cv2) => ac2 +
                    cv2.registros.reduce(
                      (ac3, cv3) => ac3 + Number(cv3.quantidade),
                      0
                    ),
                  0
                ),
              0
            )
          )}
        </td>
      </tr>
    </tbody>
  </table>;
}
